import {useNavigation} from '@react-navigation/native';
import React from 'react';
import {
  Image,
  ImageBackground,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {Images} from '../../../constants/Images';
import {styles} from './styles';
import {NavigationProps} from '../../../navigation/Routes';
import {AppRoutes} from '../../../navigation/Routes.types';

const RecoverySent = () => {
  const {navigate} = useNavigation<NavigationProps>();

  const handleNavigateLogin = () => {
    navigate(AppRoutes.LOGIN);
  };

  return (
    <ImageBackground
      // source={Images.backgroundCoke}
      style={styles.imageBackground}>
      <View style={styles.container}>
        <Image source={Images.check} style={styles.simbol} />
        <Text style={styles.title}>E-mail enviado!</Text>
        <Text style={styles.description}>
          Enviamos um e-mail com uma senha temporária. Verifique sua caixa de
          entrada e siga as instruções.
        </Text>
        <TouchableOpacity onPress={handleNavigateLogin}>
          <Text style={styles.goBack}>Voltar a tela de login</Text>
        </TouchableOpacity>
      </View>
    </ImageBackground>
  );
};

export default RecoverySent;
